import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import * as react from 'react';
import * as agent from '@tolk-ai/connectors-config-agent';
import * as genericUtils from '@tolk-ai/generic-utils';

const Component$1 = ({
  className
}) => jsxs("svg", Object.assign({
  className: className,
  height: "764.85",
  version: "1.1",
  viewBox: "0 0 2504.8 764.85",
  width: "2504.8",
  xmlns: "http://www.w3.org/2000/svg"
}, {
  children: [jsx("g", Object.assign({
    transform: "translate(-5.3994 -4.2017)"
  }, {
    children: jsx("circle", {
      cx: "2207.8",
      cy: "423.23",
      fill: "#3afb8f",
      r: "302.36",
      strokeWidth: ".5"
    }, void 0)
  }), void 0), jsx("g", Object.assign({
    transform: "translate(-5.3994 -4.2017)"
  }, {
    children: jsx("g", Object.assign({
      transform: "translate(-138.61 -685.25)"
    }, {
      children: jsx("path", {
        d: "m761.33 1453.3c-14.829-1.4895-38.075-6.5956-53.62-11.778-70.576-23.529-120.37-76.734-133.88-143.07-1.1522-5.654-1.7351-10.593-1.2954-10.975 0.43978-0.382 25.503-7.2756 55.697-15.319 54.192-14.437 54.934-14.603 57.791-12.915 1.5916 0.9402 3.1306 2.839 3.42 4.2195 7.9236 37.802 32.562 64.029 69.273 73.735 7.8326 2.071 12.689 2.6317 26.152 3.0195 67.248 1.937 105.39-28.271 113.94-90.245 1.4072-10.2 2.5996-44.5 1.5469-44.5-0.43773 0-4.3511 3.3966-8.6964 7.5481-32.003 30.576-85.407 44.093-141.8 35.89-22.528-3.2768-49.362-12.018-67.91-22.122-58.136-31.67-95.122-85.98-106.79-156.82-2.2644-13.744-2.5801-57.087-0.51352-70.5 10.168-65.995 42.746-119.15 93.948-153.3 36.211-24.147 83.085-36.064 128.64-32.704 42.372 3.1251 75.34 16.443 98.352 39.732l7.25 7.3369v-34.456l5.3742-5.6094h114.28l4.3979 4.6814-0.3179 211.91c-0.3466 231.02-0.012 217.05-5.8541 244.36-13.119 61.334-42.936 106.88-89.877 137.3-28.161 18.247-63.933 29.97-104.43 34.223-15.857 1.6652-50.139 1.8498-65.067 0.3504zm69-316.7c9.8221-2.6319 22.835-8.7544 30.928-14.551 6.925-4.9602 17.74-15.931 22.251-22.572 7.9067-11.64 14.06-27.747 16.948-44.364 2.4423-14.054 1.469-40.884-1.9559-53.913-9.562-36.378-34.746-62.368-69.671-71.902-7.3928-2.0182-10.78-2.3189-26-2.3086-21.09 0.0143-30.006 1.8609-45.5 9.4232-22.283 10.876-37.687 27.376-47.09 50.441-5.2555 12.891-7.4203 23.946-8.0525 41.124-1.895 51.486 21.266 90.022 63.643 105.89 2.475 0.9267 8.55 2.5613 13.5 3.6325 12.597 2.7257 39.225 2.2566 51-0.8986zm440 147.24c-24.986-2.8483-38.365-5.6443-57.937-12.109-72.258-23.865-125.64-81.914-145.08-157.75-6.2374-24.337-7.8575-38.472-7.9078-68.999-0.046-28.154 0.8345-37.573 5.5181-59 18.724-85.658 80.65-151.03 162.92-171.99 29.855-7.6059 66.644-8.5289 101.08-2.536 85.202 14.828 142.72 68.192 164.4 152.53 7.2529 28.21 10.35 62.706 8.4778 94.437-0.9832 16.667-1.3109 18.793-3.2089 20.813l-2.1139 2.2502h-310.65v2.8717c0 5.4393 4.955 22.389 8.9699 30.684 18.876 38.997 62.392 62.023 108.7 57.516 14.227-1.3848 21.694-3.0298 32.277-7.111 23.208-8.9499 41.439-28.469 51.446-55.082l2.114-5.6216 53.497 15.97c29.423 8.7834 53.7 16.166 53.948 16.406 0.9657 0.9341-6.4586 21.466-11.885 32.867-10.295 21.631-22.023 38.402-38.094 54.473-33.106 33.106-79.112 53.905-130.4 58.952-9.9886 0.983-38.871 1.2547-46.076 0.4334zm105.02-296.61c-6.9014-44.906-38.15-71.416-86.593-73.46-16.124-0.68046-26.719 0.62031-39.43 4.8408-22.797 7.5698-41.778 23.963-52.277 45.151-4.0513 8.1758-8.2229 21.086-8.2229 25.448v2.2701h187.18zm-1101 294.76c-49.683-7.0377-88.766-31.178-111.88-69.102-12.827-21.048-19.763-49.556-18.225-74.907 3.5653-58.766 38.565-101.39 99.662-121.38 15.705-5.1378 24.023-6.6684 87.441-16.09 33.55-4.9842 63.259-9.7124 66.02-10.507 13.185-3.7962 19.48-12.079 19.48-25.631 0-23.934-15.531-41.44-43.5-49.032-6.718-1.8235-10.724-2.1753-25-2.1947-19.14-0.0261-26.947 1.4779-40 7.7063-21.414 10.218-36.423 30.797-39.906 54.718-0.49191 3.3781-1.3843 5.115-3.3811 6.5808l-2.7128 1.9914-54.747-11.581c-54.643-11.559-54.747-11.586-54.747-14.081 1e-3 -10.986 7.7247-37.531 15.319-52.652 25.932-51.634 76.156-85.636 141.88-96.057 15.807-2.5062 60.962-2.4747 78.29 0.0545 36.145 5.2758 64.652 15.487 88.694 31.772 12.289 8.3236 29.555 25.658 37.67 37.819 10.199 15.285 17.81 32.69 22.546 51.564 5.0947 20.302 4.8519 13.375 5.5903 159.5 0.67732 134.04 0.85615 141.25 4.1234 166.16 1.0843 8.2692 1.0361 8.8032-1.0622 11.75l-2.1982 3.0871h-56.325c-48.44 0-56.403-0.2042-56.885-1.459-0.9765-2.5447-3.5299-21.672-4.2395-31.757l-0.68366-9.7164-9.1155 9.2702c-10.182 10.355-17.475 16.192-28.888 23.121-14.983 9.0964-35.64 16.622-55.228 20.119-12.598 2.2494-45.021 2.7703-58 0.9318zm80.5-99.817c17.692-4.6043 28.103-10.66 39.731-23.112 15.527-16.626 22.751-40.084 22.064-71.644l-0.2951-13.563-50.317 7.764c-27.674 4.2702-53.475 8.7607-57.334 9.9788-12.575 3.9688-24.051 12.386-29.545 21.669-6.4753 10.942-8.2512 27.7-4.2935 40.513 4.0175 13.007 15.315 24.048 29.223 28.56 9.1402 2.965 9.8586 3.0376 26.266 2.6555 11.909-0.2774 16.958-0.8589 24.5-2.8217zm1817 94.709c-16.749-2.0283-21.738-2.8844-31.555-5.4158-37.489-9.6662-67.064-33.398-82.372-66.097-4.9329-10.538-8.3087-20.594-11.208-33.389-2.2631-9.9862-2.267-10.156-2.8156-123l-0.5493-113-37.449-0.26237c-36.829-0.25803-37.487-0.29816-39.75-2.4243l-2.3013-2.162v-106.3l2.3145-2.1743c2.1892-2.0566 3.2357-2.1743 19.34-2.1743 13.601 0 18.558-0.39184 24.642-1.9481 20.37-5.2098 33.778-17.635 40.436-37.474l2.7111-8.0784 0.3412-39.5c0.3332-38.58 0.3903-39.552 2.4525-41.75l2.1114-2.25h108.3l4.3486 4.6289v126.37h41.596c40.449 0 41.676 0.057 44.5 2.0681l2.9044 2.0681v106.52l-2.3026 2.1632c-2.2753 2.1375-2.8005 2.1663-44.25 2.4243l-41.947 0.26113v96c0 102.87-0.07 101.32 5.0474 111.54 6.147 12.275 20.905 18.93 42.029 18.952 8.2924 0.01 27.558-1.7568 32.038-2.9362 2.5494-0.6712 3.6825-0.3749 6.25 1.6344l3.136 2.4544v101.71l-5.4389 2.035c-8.1091 3.034-20.353 5.9806-31.84 7.6626-9.9808 1.4615-43.752 2.6917-50.722 1.8477zm-629.83-7.716-2.1743-2.3145v-442.02l4.6289-4.3486h114.76l5.6094 5.3742v37.654l9.7647-9.7641c21.205-21.204 46.298-34.315 79.235-41.403 9.1638-1.9718 13.49-2.2658 34-2.3105 24.608-0.0536 30 0.51227 48.299 5.0688 28.649 7.1334 55.467 23.283 73.226 44.097 21.866 25.626 34.683 56.967 40.604 99.283 0.8608 6.1512 1.2969 49.782 1.5782 157.89l0.3889 149.39-5.4711 5.7106h-118.02l-5.6094-5.3742v-134.06c0-146.92 0.1028-144.01-5.9292-160.54-9.8101-26.88-29.971-41.908-60.371-45.001-47.851-4.8674-81.952 24.107-87.66 74.48-0.6405 5.6532-1.0227 56.812-1.0279 137.58l-0.01 128.58-4.6289 4.3486h-119.02l-2.1743-2.3144z",
        fill: "#32006c"
      }, void 0)
    }), void 0)
  }), void 0)]
}), void 0);

var styles = {"channelcard":"index-module_channelcard__8TZbT","channelcard--disabled":"index-module_channelcard--disabled__tsRIS","channelcard__icon":"index-module_channelcard__icon__4MStn","channelcard__title":"index-module_channelcard__title__3pCy6","channelcard__button":"index-module_channelcard__button__FdENh","channelcard__text":"index-module_channelcard__text__BlKQF","channelcard__status-indicator":"index-module_channelcard__status-indicator__JmgIE"};

const Component = ({
  mode,
  title,
  text,
  disabled: _disabled = false,
  onButtonClick
}) => jsxs("article", Object.assign({
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  className: classNames(styles.channelcard, {
    [styles['channelcard--disabled']]: _disabled
  })
}, {
  children: [jsx(Component$1, {
    className: styles.channelcard__icon
  }, void 0), jsx("h1", Object.assign({
    className: styles.channelcard__title
  }, {
    children: title
  }), void 0), mode === 'status' && jsxs("p", Object.assign({
    className: styles.channelcard__text
  }, {
    children: [jsx("span", {
      className: styles['channelcard__status-indicator']
    }, void 0), jsx("span", {
      children: text
    }, void 0)]
  }), void 0), mode === 'text' && jsx("p", Object.assign({
    className: styles.channelcard__text
  }, {
    children: text
  }), void 0), mode === 'button' && jsx("button", Object.assign({
    className: styles.channelcard__button,
    onClick: onButtonClick,
    type: "button"
  }, {
    children: text
  }), void 0)]
}), void 0);

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Component: Component
});

const onInit = (getOneAgentConfigByBotId, setMode, setText) => async botId => {
  try {
    const result = await getOneAgentConfigByBotId(botId);

    if (genericUtils.isDomainError(result, agent.appPorts.GetOneAgentConfigByBotIdErrors)) {
      setMode('button');
      return setText('Discover');
    }

    switch (result.status) {
      case true:
        setMode('status');
        setText('active');
        break;

      case false:
        setMode('button');
        setText('Discover');
        break;

      default:
    }
  } catch (_a) {
    setMode('text');
    setText('Unable to get status');
  }
};

const container = getOneAgentConfigByBotId => ({
  botId,
  onButtonClick
}) => {
  const [mode, setMode] = react.useState('text');
  const [text, setText] = react.useState('checking');
  react.useEffect(() => {
    void onInit(getOneAgentConfigByBotId, setMode, setText)(botId);
  }, []);
  return jsx(Component, {
    mode: mode,
    onButtonClick: onButtonClick,
    text: text,
    title: "Tolk Agent"
  }, void 0);
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  container: container
});

export { index as agentStatus, index$1 as channelCard };
